import './App.css';
import NexratesCounterparties from './components/NexratesCounterparties';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useAuth } from 'react-oidc-context';
import { useEffect } from 'react';

function App() {

  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading) {
      auth.signinRedirect();
    }

    if (auth.isAuthenticated && !auth.isLoading) {
      let cleanURL = window.location.pathname;
      console.log("Clean URL: " + cleanURL);
      if (cleanURL.endsWith("/callback")) {
        cleanURL = cleanURL.slice(0, -"/callback".length + 1);
        console.log("Clean URL: " + cleanURL);
      }
      window.history.replaceState({}, document.title, cleanURL); // This removes query params
    }    
  }, [auth]);

  return (
    auth.isAuthenticated ? <NexratesCounterparties /> : <div>Redirecting...</div>
  );
}

export default App;
